<template>
  <ContentContainer variant="error">
    <NotFound />
  </ContentContainer>
</template>

<script>
export default { name: "NotFoundWrapper" }
</script>
